<div class="assessores m-4 p-0 ">
  <div class="group-cards">
    <div class="cards-top">
      <icons-primecap name="pasta"></icons-primecap>
      <div class="group-info-top">
        <p class="text-aux">Quantidade de Assessores</p>
        <p class="info">{{ quantidadeAssessores }}</p>
      </div>
    </div>
    <div class="cards-top">
      <icons-primecap name="dollar"></icons-primecap>
      <div class="group-info-top">
        <p class="text-aux">Assessores Ativos</p>
        <p class="info">{{ quantidadeAssessoresAtivos }}</p>
      </div>
    </div>
  </div>
  <div class="assessores-container">
    <div class="info-assessores">
      <div class="group-assessores-top">
        <icons-primecap name="users"></icons-primecap>
        <p class="info p-bold">Assessores</p>
      </div>
      <hr class="divisor">

      <div class="lista-assessores">
        <app-tabela-crud
          [definicaoColuna]="colunasTabela"
          [dadosTabela]="assessoresEscritorio"
          [exibirBusca]="false"
          [exibirPaginador]="false"
          >
        </app-tabela-crud>
        <!--
          [exibirColunaCrud]="true"
          [exibirDashboard]="true"
          (acaoExtra)="executarAcaoExtra($event)"
         -->
      </div>
    </div>
  </div>
</div>
